import { Assets } from '../core/Assets';
import AbstractDispatcher from 'frontools/abstract/AbstractDispatcher';
import { Attrapegrippette } from "sources/js/attrapegripette/Attrapegrippette";
import { autobind } from 'frontools/decorators/Autobind';
import EventType from 'frontools/events/EventType';
import NumberUtils from 'frontools/utils/NumberUtils';

export class Microbe extends AbstractDispatcher {
    
    public static CLICK_MICROBE             :       string       = "CLICK_MICROBE";
    public static HIT_LUMBER                :       string       = "HIT_LUMBER";
    
    private _positionPoss                   : number[];

    private _game           :       Attrapegrippette          = Attrapegrippette.instance;
    private _container      :       PIXI.Container;
    private _sprite         :       PIXI.extras.AnimatedSprite;
    private _microbeNumber  :       number;
    private _microbeSound   :       PIXI.extras.AnimatedSprite;
    
    private _speedDelay     :       number          = 9;
    private _tween          :       TweenMax;

    private _touched        :       boolean         = false;
    private _clicked        :       boolean         = false;


    constructor(microbeNumber:number, isTouch:boolean) {
        super();
        this._microbeNumber = microbeNumber;
        this._sprite =  Assets.getSpriteFromJson('microbe'+this._microbeNumber);
        this._positionPoss = [-50, (this._game.screenHeight + 50)]

        this._sprite.interactive = true;
        this._sprite.buttonMode = true;
        this._container = new PIXI.Container();

        if (isTouch) { this._speedDelay = 6; }

        this._throwMicrobe();
    }

    protected _throwMicrobe(){
        let mPosition = [this._randomX, this._randomY];

        this._sprite.pivot.x = this._sprite.width / 2;
        this._sprite.pivot.y = this._sprite.height / 2;

        mPosition[Math.floor(Math.random() * 2)]();
    };

    @autobind
    protected _randomY() {
        let mx = this._positionPoss[Math.floor(Math.random() * 2)];
        let my = NumberUtils.random(0, this._game.screenHeight);

        this._createMicrobe(mx, my);
    };

    @autobind
    protected _randomX() {
        let mx = NumberUtils.random(0, this._game.screenWidth);
        let my = this._positionPoss[Math.floor(Math.random() * 2)];

        this._createMicrobe(mx, my);
    };

    protected _createMicrobe(mx: number, my: number) {
        this._sprite.x = mx;
        this._sprite.y = my;

        this._container.addChild(this._sprite);
        this._sprite.on('click', this._clickedSprite, this);
        this._sprite.on('tap', this._clickedSprite, this);
        
        this._tween = TweenMax.to(this._sprite, this._speedDelay, {y: (this._game.screenHeight / 2) + 50, x: this._game.screenWidth / 2,  ease: Linear.easeNone,
            onUpdate: this._onUpdate 
        });    
    };

    @autobind
    private _onUpdate(e) {
        this._tween.timeScale( this._game.timeScale )   

        // Collision detection
        var minX = this._game.getLumberHitZoneX().min;
        var maxX = this._game.getLumberHitZoneX().max;  
        var minY = this._game.getLumberHitZoneY().min;
        var maxY = this._game.getLumberHitZoneY().max;  
        
        if (this._sprite.x > minX && this._sprite.x < maxX && this._sprite.y > minY && this._sprite.y < maxY && this._touched === false && this._clicked === false) {
            this._hitLumber();
        }
    }
    @autobind
    private _hitLumber(){ 
        this.dispatch({type:Microbe.HIT_LUMBER, microbe:this, microbeNum:this._microbeNumber}); 
        this._sprite.play();
        this._touched = true;
        this._sprite.onFrameChange = function(frame) {
            if (frame === this._sprite.totalFrames-1) this._delete();
        }.bind(this);
    }

    @autobind
    private _clickedSprite(){
        this.dispatch({type:Microbe.CLICK_MICROBE, microbe:this, microbeNum:this._microbeNumber}); 
        this._sprite.play();
        this._clicked = true;
        this._sprite.onFrameChange = function(frame) {
            if (frame === this._sprite.totalFrames-1) this._delete();
        }.bind(this);
    }

    @autobind
    private _delete() {
        this._container.removeChild(this._sprite); 
        this._touched = true;
    }

    public get sprite() : PIXI.extras.AnimatedSprite {
        return this._sprite;    
    }
    
    public get container() : PIXI.Container {
        return this._container;    
    }
}